const warn = (s) => {
  console.warn('[analytics-service]', s);
};

export default warn;
